module.exports = __webpack_public_path__ + "a0c44a3aa9505c613a8d7d3176ba4bd5.png";